// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3K283","title":"BackImages_title__27TN6","images":"BackImages_images__LDB0t"};